var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitToPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28.6 37.5h-15c-3.1 0-5.7-2.5-5.7-5.7V10.7C8 7.6 10.5 5 13.7 5h15.2c3.1 0 5.7 2.5 5.7 5.7v21.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M14.6 24.6l-3.1-3 3-3.1M12.5 21.6l4.9-.1M28.1 18.4l3 3-2.9 3.1M30.2 21.4l-5.1.1M18.4 13l3-3 3 3M21.4 10.9l.1 6.9M24.6 29.9l-3 3.1-3.1-3M21.6 32.1l-.1-6.9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 21.4,
    cy: 21.5,
    r: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitToPage);
export default __webpack_public_path__ + "static/media/fitToPage.302fb3c5e34633f27b52297c69132be9.svg";
export { ForwardRef as ReactComponent };